[
  {
    "gtin": "01000001",
    "name": "Apple Juice",
    "brandName": "FreshFarms",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 1.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745001502/products/pim/8700216595841-774432430/pampers-baby-pants-baby-dry-gr-4-maxi-9-15-kg-big-pack",
    "imageOutline": {
      "x0": 0.255,
      "y0": 0.0,
      "x1": 0.75,
      "y1": 1.0,
      "aspect": 0.495
    },
    "placements": [
      {
        "shelfId": "VBK4",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3c3d9bab0f83ff4eb9"
      },
      {
        "shelfId": "H9YO",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3c3d9bab0f83ff4e91"
      },
      {
        "shelfId": "U0ES",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3c3d9bab0f83ff4e9a"
      }
    ],
    "inventory": {
      "quantity": 58
    }
  },
  {
    "gtin": "01000002",
    "name": "Banana Chips",
    "brandName": "SnackCo",
    "baseCategory": "Snacks",
    "reportedPrice": {
      "amount": 1.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.59,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1746066918/products/pim/4015637827094-2085653840/bauck-muehle-backmischung-wunderbrot-mit-nuessen-glutenfrei",
    "imageOutline": {
      "x0": 0.28,
      "y0": 0.0,
      "x1": 0.72,
      "y1": 1.0,
      "aspect": 0.44
    },
    "placements": [
      {
        "shelfId": "VBK4",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3c3d9bab0f83ff4ea4"
      },
      {
        "shelfId": "DEZN",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3c3d9bab0f83ff4ec1"
      }
    ],
    "inventory": {
      "quantity": 0
    }
  },
  {
    "gtin": "01000003",
    "name": "Carrot Cake",
    "brandName": "SweetTreats",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 2.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745005312/products/pim/4015200035864-945397344/spee-colorwaschmittel-megaperls",
    "imageOutline": {
      "x0": 0.08,
      "y0": 0.0,
      "x1": 0.925,
      "y1": 1.0,
      "aspect": 0.845
    },
    "placements": [
      {
        "shelfId": "3WYZ",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3c3d9bab0f83ff4ee4"
      },
      {
        "shelfId": "SCAP",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3c3d9bab0f83ff4ec4"
      },
      {
        "shelfId": "IFRD",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3c3d9bab0f83ff4f35"
      }
    ],
    "inventory": {
      "quantity": 34
    }
  },
  {
    "gtin": "01000004",
    "name": "Dairy Milk",
    "brandName": "MilkyWay",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 0.89,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 0.99,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744963666/products/pim/4066447240887-602781997/balea-professional-conditioner-keratin",
    "imageOutline": {
      "x0": 0.255,
      "y0": 0.0,
      "x1": 0.75,
      "y1": 1.0,
      "aspect": 0.495
    },
    "placements": [
      {
        "shelfId": "UJGZ",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3c3d9bab0f83ff4fe0"
      },
      {
        "shelfId": "QC7U",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3c3d9bab0f83ff500e"
      }
    ],
    "inventory": {
      "quantity": 2
    }
  },
  {
    "gtin": "01000005",
    "name": "Egg Noodles",
    "brandName": "NoodleNest",
    "baseCategory": "Pasta & Noodles",
    "reportedPrice": {
      "amount": 1.79,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.89,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1748394962/products/pim/4056631003879-1043270438/aptamil-anfangsmilch-1-pronutra-von-geburt-an",
    "imageOutline": {
      "x0": 0.15,
      "y0": 0.0,
      "x1": 0.85,
      "y1": 1.0,
      "aspect": 0.7
    },
    "placements": [
      {
        "shelfId": "SCAP",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3c3d9bab0f83ff4ec5"
      },
      {
        "shelfId": "IFRD",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3c3d9bab0f83ff4f70"
      },
      {
        "shelfId": "7YSF",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3c3d9bab0f83ff5066"
      }
    ],
    "inventory": {
      "quantity": 20
    }
  },
  {
    "gtin": "01000006",
    "name": "Fig Bars",
    "brandName": "HealthySnacks",
    "baseCategory": "Snacks",
    "reportedPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744981606/products/pim/4066447710144-2080378097/babylove-baby-badezusatz-entspannendes-schlaf-schoen-bad-sensitive",
    "imageOutline": {
      "x0": 0.325,
      "y0": 0.0,
      "x1": 0.675,
      "y1": 1.0,
      "aspect": 0.35
    },
    "placements": [
      {
        "shelfId": "8SMF",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff5094"
      },
      {
        "shelfId": "ZQ0I",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3d3d9bab0f83ff50c2"
      }
    ],
    "inventory": {
      "quantity": 42
    }
  },
  {
    "gtin": "01000007",
    "name": "Grape Soda",
    "brandName": "FizzPop",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 0.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.09,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744817157/products/pim/4031244004253-3807513/humana-anfangsmilch-1",
    "imageOutline": {
      "x0": 0.16,
      "y0": 0.0,
      "x1": 0.84,
      "y1": 1.0,
      "aspect": 0.68
    },
    "placements": [
      {
        "shelfId": "5XWF",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff508e"
      },
      {
        "shelfId": "U4OH",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff511d"
      },
      {
        "shelfId": "5XUT",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3d3d9bab0f83ff5137"
      }
    ],
    "inventory": {
      "quantity": 48
    }
  },
  {
    "gtin": "01000008",
    "name": "Honey Oats",
    "brandName": "BreakfastBest",
    "baseCategory": "Cereals & Breakfast",
    "reportedPrice": {
      "amount": 3.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744999054/products/pim/8700216678384-453297811/ariel-colorwaschmittel-pods",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.035,
      "x1": 1.0,
      "y1": 0.96,
      "aspect": 1.0811
    },
    "placements": [
      {
        "shelfId": "KP5H",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3d3d9bab0f83ff5193"
      },
      {
        "shelfId": "CZR6",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff51db"
      }
    ],
    "inventory": {
      "quantity": 56
    }
  },
  {
    "gtin": "01000009",
    "name": "Ice Cream",
    "brandName": "CoolTreats",
    "baseCategory": "Frozen Foods",
    "reportedPrice": {
      "amount": 4.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 5.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744978453/products/pim/4066447725285-2013402493/balea-bodycreme-sheabutter-und-arganoel",
    "imageOutline": {
      "x0": 0.065,
      "y0": 0.0,
      "x1": 0.93,
      "y1": 1.0,
      "aspect": 0.865
    },
    "placements": [
      {
        "shelfId": "O99O",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3d3d9bab0f83ff522f"
      },
      {
        "shelfId": "U85I",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff5262"
      },
      {
        "shelfId": "J55R",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff5291"
      },
      {
        "shelfId": "X8IJ",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff5349"
      }
    ],
    "inventory": {
      "quantity": 7
    }
  },
  {
    "gtin": "01000010",
    "name": "Jelly Beans",
    "brandName": "CandyLand",
    "baseCategory": "Sweets & Confectionery",
    "reportedPrice": {
      "amount": 1.29,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.39,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744986814/products/pim/4066447107135-405920019/alverde-men-bartserum-rough-nature",
    "imageOutline": {
      "x0": 0.33,
      "y0": 0.0,
      "x1": 0.665,
      "y1": 1.0,
      "aspect": 0.335
    },
    "placements": [
      {
        "shelfId": "U0JR",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff53b9"
      },
      {
        "shelfId": "XKQG",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff53ef"
      }
    ],
    "inventory": {
      "quantity": 10
    }
  },
  {
    "gtin": "01000011",
    "name": "Kiwi Jam",
    "brandName": "FruitDelight",
    "baseCategory": "Spreads",
    "reportedPrice": {
      "amount": 2.19,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.39,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1746617801/products/pim/4067796069204-1438651370/seinz-anti-aging-creme",
    "imageOutline": {
      "x0": 0.03,
      "y0": 0.0,
      "x1": 0.975,
      "y1": 1.0,
      "aspect": 0.945
    },
    "placements": [
      {
        "shelfId": "DCMY",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5f70"
      }
    ],
    "inventory": {
      "quantity": 49
    }
  },
  {
    "gtin": "01000012",
    "name": "Lemonade",
    "brandName": "CitrusFresh",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 1.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744998292/products/pim/8700216569873-695182165/ariel-colorwaschmittel-fluessig",
    "imageOutline": {
      "x0": 0.245,
      "y0": 0.0,
      "x1": 0.76,
      "y1": 1.0,
      "aspect": 0.515
    },
    "placements": [
      {
        "shelfId": "E0W2",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff5738"
      }
    ],
    "inventory": {
      "quantity": 26
    }
  },
  {
    "gtin": "01000013",
    "name": "Mango Lassi",
    "brandName": "Yogurto",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 0.89,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 0.99,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1749799446/products/pim/4058172684128-2083871543/mivolis-beauty-kollagen-hyaluron-trinkampullen-20-st",
    "imageOutline": {
      "x0": 0.08,
      "y0": 0.0,
      "x1": 0.92,
      "y1": 1.0,
      "aspect": 0.84
    },
    "placements": [
      {
        "shelfId": "HVVZ",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3d3d9bab0f83ff5755"
      }
    ],
    "inventory": {
      "quantity": 0
    }
  },
  {
    "gtin": "01000014",
    "name": "Nutty Bars",
    "brandName": "SnackCo",
    "baseCategory": "Snacks",
    "reportedPrice": {
      "amount": 1.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744816509/products/pim/662834508765-3727234/zeiss-brillen-reinigungstuecher",
    "imageOutline": {
      "x0": 0.245,
      "y0": 0.0,
      "x1": 0.755,
      "y1": 1.0,
      "aspect": 0.51
    },
    "placements": [
      {
        "shelfId": "JCBY",
        "stockLevel": "UNKNOWN",
        "facingId": "679afb3d3d9bab0f83ff5790"
      }
    ],
    "inventory": {
      "quantity": 24
    }
  },
  {
    "gtin": "01000015",
    "name": "Olive Oil",
    "brandName": "PurePress",
    "baseCategory": "Oils & Vinegars",
    "reportedPrice": {
      "amount": 3.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 4.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744985504/products/pim/4066447668711-187619804/babylove-baby-pants-premium-gr-5-junior-13-20-kg-jumbo-pack",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.04,
      "x1": 1.0,
      "y1": 0.96,
      "aspect": 1.087
    },
    "placements": [
      {
        "shelfId": "II59",
        "stockLevel": "UNKNOWN",
        "facingId": "679afb3d3d9bab0f83ff580b"
      }
    ],
    "inventory": {
      "quantity": 24
    }
  },
  {
    "gtin": "01000016",
    "name": "Peach Tea",
    "brandName": "TeaTime",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 1.29,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.39,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744995998/products/pim/4260401410778-89679819/paediprotect-baby-und-kinder-badezusatz-pflegebad",
    "imageOutline": {
      "x0": 0.305,
      "y0": 0.0,
      "x1": 0.7,
      "y1": 1.0,
      "aspect": 0.395
    },
    "placements": [
      {
        "shelfId": "4N8Z",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3d3d9bab0f83ff5845"
      }
    ],
    "inventory": {
      "quantity": 22
    }
  },
  {
    "gtin": "01000017",
    "name": "Quinoa Salad",
    "brandName": "HealthyChoice",
    "baseCategory": "Salads",
    "reportedPrice": {
      "amount": 4.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 4.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1746707708/products/pim/4066447750645-1928711266/balea-men-antitranspirant-deo-roll-on-extra-dry",
    "imageOutline": {
      "x0": 0.315,
      "y0": 0.0,
      "x1": 0.69,
      "y1": 1.0,
      "aspect": 0.375
    },
    "placements": [
      {
        "shelfId": "T80E",
        "stockLevel": "UNKNOWN",
        "facingId": "679afb3d3d9bab0f83ff582e"
      }
    ],
    "inventory": {
      "quantity": 11
    }
  },
  {
    "gtin": "01000018",
    "name": "Raspberry Yogurt",
    "brandName": "DairyDream",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 0.79,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 0.89,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744996009/products/pim/4006000131030-279849504/nivea-sun-after-sun-balsam-im-tiegel",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.075,
      "x1": 1.0,
      "y1": 0.925,
      "aspect": 1.1765
    },
    "placements": [
      {
        "shelfId": "PM2N",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff614a"
      }
    ],
    "inventory": {
      "quantity": 49
    }
  },
  {
    "gtin": "01000019",
    "name": "Strawberry Jam",
    "brandName": "BerryBest",
    "baseCategory": "Spreads",
    "reportedPrice": {
      "amount": 2.19,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.39,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744980898/products/pim/4066447710083-413034/babylove-baby-kopf-bis-fuss-waschgel-nachfuellpack",
    "imageOutline": {
      "x0": 0.215,
      "y0": 0.005,
      "x1": 0.79,
      "y1": 1.0,
      "aspect": 0.5779
    },
    "placements": [
      {
        "shelfId": "OTUP",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3d3d9bab0f83ff585d"
      }
    ],
    "inventory": {
      "quantity": 59
    }
  },
  {
    "gtin": "01000020",
    "name": "Tomato Soup",
    "brandName": "SoupMaster",
    "baseCategory": "Canned & Jarred",
    "reportedPrice": {
      "amount": 1.89,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.09,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744994041/products/pim/4260380014011-70582103/brooklyn-soap-company-bartroller",
    "imageOutline": {
      "x0": 0.325,
      "y0": 0.0,
      "x1": 0.68,
      "y1": 1.0,
      "aspect": 0.355
    },
    "placements": [
      {
        "shelfId": "L4QV",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff63a1"
      }
    ],
    "inventory": {
      "quantity": 0
    }
  },
  {
    "gtin": "01000021",
    "name": "Udon Noodles",
    "brandName": "NoodleNest",
    "baseCategory": "Pasta & Noodles",
    "reportedPrice": {
      "amount": 1.79,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.89,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744996486/products/pim/4006000087719-668401390/nivea-anti-falten-augencreme-q10-energy",
    "imageOutline": {
      "x0": 0.345,
      "y0": 0.0,
      "x1": 0.655,
      "y1": 1.0,
      "aspect": 0.31
    },
    "placements": [
      {
        "shelfId": "U85I",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3c3d9bab0f83ff5286"
      }
    ],
    "inventory": {
      "quantity": 45
    }
  },
  {
    "gtin": "01000022",
    "name": "Vanilla Pudding",
    "brandName": "SweetTreats",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 0.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.09,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744996005/products/pim/4018852029359-1743843223/bebivita-abendbrei-keks-banane-ab-dem-6-monat",
    "imageOutline": {
      "x0": 0.19,
      "y0": 0.0,
      "x1": 0.81,
      "y1": 1.0,
      "aspect": 0.62
    },
    "placements": [
      {
        "shelfId": "JCBY",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3d3d9bab0f83ff57aa"
      }
    ],
    "inventory": {
      "quantity": 12
    }
  },
  {
    "gtin": "01000023",
    "name": "Walnut Brownies",
    "brandName": "NuttyBakes",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 3.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745887334/products/pim/4009077026018-179681980/em-eukal-bonbon-ingwer-orange-zuckerfrei",
    "imageOutline": {
      "x0": 0.155,
      "y0": 0.02,
      "x1": 0.845,
      "y1": 1.0,
      "aspect": 0.7041
    },
    "placements": [
      {
        "shelfId": "KJJO",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5ba2"
      }
    ],
    "inventory": {
      "quantity": 59
    }
  },
  {
    "gtin": "01000024",
    "name": "Xylitol Gum",
    "brandName": "FreshChew",
    "baseCategory": "Gum & Mints",
    "reportedPrice": {
      "amount": 0.79,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 0.89,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744962789/products/pim/4066447242553-2052687387/balea-abdeckstift-hautrein-pickel-20-mittlerer-hautton",
    "imageOutline": {
      "x0": 0.125,
      "y0": 0.0,
      "x1": 0.88,
      "y1": 1.0,
      "aspect": 0.755
    },
    "placements": [
      {
        "shelfId": "YALM",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5945"
      }
    ],
    "inventory": {
      "quantity": 47
    }
  },
  {
    "gtin": "01000025",
    "name": "Yogurt Drink",
    "brandName": "DairyDream",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 0.89,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 0.99,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744998713/products/pim/4006000131467-926683978/hidrofugal-antitranspirant-deospray-men-frisch-und-stark",
    "imageOutline": {
      "x0": 0.37,
      "y0": 0.0,
      "x1": 0.635,
      "y1": 1.0,
      "aspect": 0.265
    },
    "placements": [
      {
        "shelfId": "DA90",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5fe4"
      }
    ],
    "inventory": {
      "quantity": 0
    }
  },
  {
    "gtin": "01000026",
    "name": "Zucchini Bread",
    "brandName": "VeggieBake",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 2.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1747440375/products/pim/42449508-355616148/nivea-men-antitranspirant-deo-roll-on-black-und-white",
    "imageOutline": {
      "x0": 0.31,
      "y0": 0.0,
      "x1": 0.695,
      "y1": 1.0,
      "aspect": 0.385
    },
    "placements": [
      {
        "shelfId": "U4OH",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3d3d9bab0f83ff5119"
      }
    ],
    "inventory": {
      "quantity": 57
    }
  },
  {
    "gtin": "01000027",
    "name": "Almond Milk",
    "brandName": "NutriMilk",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 1.09,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1754534084/products/pim/4066447759129-1670689767/dmbio-beluga-linsen",
    "imageOutline": {
      "x0": 0.195,
      "y0": 0.0,
      "x1": 0.8,
      "y1": 1.0,
      "aspect": 0.605
    },
    "placements": [
      {
        "shelfId": "CZR6",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3c3d9bab0f83ff51db"
      }
    ],
    "inventory": {
      "quantity": 32
    }
  },
  {
    "gtin": "01000028",
    "name": "Berry Smoothie",
    "brandName": "SmoothieKing",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 2.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744808414/products/pim/4058172737381-3518267/dmbio-brotaufstrich-vegane-pastete-shiitake-champignon",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.115,
      "x1": 1.0,
      "y1": 0.885,
      "aspect": 1.2987
    },
    "placements": [
      {
        "shelfId": "MKFF",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6317"
      }
    ],
    "inventory": {
      "quantity": 15
    }
  },
  {
    "gtin": "01000029",
    "name": "Coconut Water",
    "brandName": "TropicalTaste",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 1.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744756833/products/pim/4015537442328-2574460/hammermuehle-backmischung-kastanienbrot-glutenfrei",
    "imageOutline": {
      "x0": 0.29,
      "y0": 0.0,
      "x1": 0.705,
      "y1": 1.0,
      "aspect": 0.415
    },
    "placements": [
      {
        "shelfId": "J55R",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff529d"
      }
    ],
    "inventory": {
      "quantity": 23
    }
  },
  {
    "gtin": "01000030",
    "name": "Date Bars",
    "brandName": "HealthySnacks",
    "baseCategory": "Snacks",
    "reportedPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744977790/products/pim/4066447599466-1991005610/dmbio-brezeln-dinkel-ohne-aufstreusalz-mini",
    "imageOutline": {
      "x0": 0.185,
      "y0": 0.0,
      "x1": 0.81,
      "y1": 1.0,
      "aspect": 0.625
    },
    "placements": [
      {
        "shelfId": "K3DS",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff5523"
      }
    ],
    "inventory": {
      "quantity": 3
    }
  },
  {
    "gtin": "01000031",
    "name": "Earl Grey Tea",
    "brandName": "TeaTime",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 1.29,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.39,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744985381/products/pim/4067796063813-1407495088/dmbio-backmischung-krustenbrot",
    "imageOutline": {
      "x0": 0.275,
      "y0": 0.0,
      "x1": 0.72,
      "y1": 1.0,
      "aspect": 0.445
    },
    "placements": [
      {
        "shelfId": "90YA",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5a6d"
      }
    ],
    "inventory": {
      "quantity": 30
    }
  },
  {
    "gtin": "01000032",
    "name": "Fruit Punch",
    "brandName": "FizzPop",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 1.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744980050/products/pim/4008617138822-1009462392/klosterfrau-arnika-intensiv-creme",
    "imageOutline": {
      "x0": 0.34,
      "y0": 0.0,
      "x1": 0.66,
      "y1": 1.0,
      "aspect": 0.32
    },
    "placements": [
      {
        "shelfId": "4N8Z",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3d3d9bab0f83ff581b"
      }
    ],
    "inventory": {
      "quantity": 48
    }
  },
  {
    "gtin": "01000033",
    "name": "Ginger Ale",
    "brandName": "FizzPop",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 0.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.09,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744999302/products/pim/4066447668612-1261545513/babylove-baby-pants-premium-gr-5-junior-13-20-kg",
    "imageOutline": {
      "x0": 0.155,
      "y0": 0.0,
      "x1": 0.84,
      "y1": 1.0,
      "aspect": 0.685
    },
    "placements": [
      {
        "shelfId": "TT3H",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5cc1"
      }
    ],
    "inventory": {
      "quantity": 0
    }
  },
  {
    "gtin": "01000034",
    "name": "Hazelnut Spread",
    "brandName": "NuttyBakes",
    "baseCategory": "Spreads",
    "reportedPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745842419/products/pim/4066447678345-536132220/profissimo-backpapier-zuschnitte",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.435,
      "x1": 1.0,
      "y1": 0.565,
      "aspect": 7.6923
    },
    "placements": [
      {
        "shelfId": "IS38",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3e3d9bab0f83ff6003"
      }
    ],
    "inventory": {
      "quantity": 41
    }
  },
  {
    "gtin": "01000035",
    "name": "Italian Pasta",
    "brandName": "NoodleNest",
    "baseCategory": "Pasta & Noodles",
    "reportedPrice": {
      "amount": 1.79,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.89,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744963312/products/pim/4058172922053-2111547795/mivolis-a-z-komplett-depot-ab-50-tabletten-100-st",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.04,
      "x1": 1.0,
      "y1": 0.955,
      "aspect": 1.0929
    },
    "placements": [
      {
        "shelfId": "T2D2",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3c3d9bab0f83ff4f2b"
      }
    ],
    "inventory": {
      "quantity": 39
    }
  },
  {
    "gtin": "01000036",
    "name": "Jackfruit Chips",
    "brandName": "SnackCo",
    "baseCategory": "Snacks",
    "reportedPrice": {
      "amount": 1.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745887567/products/pim/4009077024007-1711263181/em-eukal-bonbon-klassisch",
    "imageOutline": {
      "x0": 0.125,
      "y0": 0.0,
      "x1": 0.87,
      "y1": 1.0,
      "aspect": 0.745
    },
    "placements": [
      {
        "shelfId": "X7I1",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6452"
      }
    ],
    "inventory": {
      "quantity": 9
    }
  },
  {
    "gtin": "01000037",
    "name": "Kale Salad",
    "brandName": "HealthyChoice",
    "baseCategory": "Salads",
    "reportedPrice": {
      "amount": 3.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 4.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744998311/products/pim/4006000139395-1264530268/nivea-sun-after-sun-milch-mit-aloe-vera-und-hyaluron",
    "imageOutline": {
      "x0": 0.32,
      "y0": 0.0,
      "x1": 0.685,
      "y1": 1.0,
      "aspect": 0.365
    },
    "placements": [
      {
        "shelfId": "BH23",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5e1f"
      }
    ],
    "inventory": {
      "quantity": 24
    }
  },
  {
    "gtin": "01000038",
    "name": "Lime Soda",
    "brandName": "FizzPop",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 0.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.09,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744985152/products/pim/4021457660322-14537606/lavera-naturkosmetik-bodylotion-barrier-balance",
    "imageOutline": {
      "x0": 0.295,
      "y0": 0.0,
      "x1": 0.705,
      "y1": 1.0,
      "aspect": 0.41
    },
    "placements": [
      {
        "shelfId": "ZRKO",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3f3d9bab0f83ff62fe"
      }
    ],
    "inventory": {
      "quantity": 39
    }
  },
  {
    "gtin": "01000039",
    "name": "Mint Chutney",
    "brandName": "TropicalTaste",
    "baseCategory": "Condiments",
    "reportedPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745000690/products/pim/59099727-1444515668/dove-men-care-antitranspirant-deostick-invisible-dry",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.22,
      "x1": 1.0,
      "y1": 0.78,
      "aspect": 1.7857
    },
    "placements": [
      {
        "shelfId": "JL9L",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5b9f"
      }
    ],
    "inventory": {
      "quantity": 29
    }
  },
  {
    "gtin": "01000040",
    "name": "Orange Juice",
    "brandName": "FreshFarms",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 1.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745001429/products/pim/4056631002414-1622481260/aptamil-anfangsmilch-pre-trinkfertig-von-geburt-an-4x200ml",
    "imageOutline": {
      "x0": 0.095,
      "y0": 0.0,
      "x1": 0.9,
      "y1": 1.0,
      "aspect": 0.805
    },
    "placements": [
      {
        "shelfId": "OXVF",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3f3d9bab0f83ff62cf"
      }
    ],
    "inventory": {
      "quantity": 1
    }
  },
  {
    "gtin": "01000041",
    "name": "Papaya Jam",
    "brandName": "FruitDelight",
    "baseCategory": "Spreads",
    "reportedPrice": {
      "amount": 2.19,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.39,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744985015/products/pim/4006000085517-2058232707/nivea-anti-falten-gesichtscreme-q10-energy-lsf-15",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.09,
      "x1": 1.0,
      "y1": 0.91,
      "aspect": 1.2195
    },
    "placements": [
      {
        "shelfId": "SQDY",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5f0d"
      }
    ],
    "inventory": {
      "quantity": 43
    }
  },
  {
    "gtin": "01000042",
    "name": "Quince Jelly",
    "brandName": "BerryBest",
    "baseCategory": "Spreads",
    "reportedPrice": {
      "amount": 2.19,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.39,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744977790/products/pim/4066447599466-1991005610/dmbio-brezeln-dinkel-ohne-aufstreusalz-mini",
    "imageOutline": {
      "x0": 0.185,
      "y0": 0.0,
      "x1": 0.81,
      "y1": 1.0,
      "aspect": 0.625
    },
    "placements": [
      {
        "shelfId": "3QD4",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5aa9"
      }
    ],
    "inventory": {
      "quantity": 12
    }
  },
  {
    "gtin": "01000043",
    "name": "Raisin Bread",
    "brandName": "VeggieBake",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 3.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745001584/products/pim/4062300463455-1786658256/hipp-babysnack-knusperstangen-mit-apfel-und-karotte-ab-dem-8-monat",
    "imageOutline": {
      "x0": 0.14,
      "y0": 0.0,
      "x1": 0.86,
      "y1": 1.0,
      "aspect": 0.72
    },
    "placements": [
      {
        "shelfId": "0ZLK",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3c3d9bab0f83ff4ef5"
      }
    ],
    "inventory": {
      "quantity": 59
    }
  },
  {
    "gtin": "01000044",
    "name": "Spinach Wrap",
    "brandName": "HealthyChoice",
    "baseCategory": "Wraps & Tortillas",
    "reportedPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744829593/products/pim/4066447237542-4139974/balea-after-shave-pflege-gel-sensitive",
    "imageOutline": {
      "x0": 0.305,
      "y0": 0.0,
      "x1": 0.685,
      "y1": 1.0,
      "aspect": 0.38
    },
    "placements": [
      {
        "shelfId": "9AXY",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff54a1"
      }
    ],
    "inventory": {
      "quantity": 45
    }
  },
  {
    "gtin": "01000045",
    "name": "Tapioca Pudding",
    "brandName": "SweetTreats",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 0.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.09,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744974904/products/pim/4017512182083-219544219/deins-badesalz-cactus-crackle-mit-knistereffekt",
    "imageOutline": {
      "x0": 0.195,
      "y0": 0.0,
      "x1": 0.805,
      "y1": 1.0,
      "aspect": 0.61
    },
    "placements": [
      {
        "shelfId": "2SU4",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5b3b"
      }
    ],
    "inventory": {
      "quantity": 25
    }
  },
  {
    "gtin": "01000046",
    "name": "Ugli Fruit Juice",
    "brandName": "FreshFarms",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 1.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745000160/products/pim/4015100812336-1826313115/schwarzkopf-gliss-conditioner-aqua-revive",
    "imageOutline": {
      "x0": 0.295,
      "y0": 0.0,
      "x1": 0.7,
      "y1": 1.0,
      "aspect": 0.405
    },
    "placements": [
      {
        "shelfId": "VG4F",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5be8"
      }
    ],
    "inventory": {
      "quantity": 60
    }
  },
  {
    "gtin": "01000047",
    "name": "Vanilla Wafers",
    "brandName": "CookieJar",
    "baseCategory": "Sweets & Confectionery",
    "reportedPrice": {
      "amount": 1.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.59,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744962625/products/pim/3616301640868-113053532/bruno-banani-absolute-man-eau-de-toilette",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.02,
      "x1": 1.0,
      "y1": 0.975,
      "aspect": 1.0471
    },
    "placements": [
      {
        "shelfId": "OWNW",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5bf9"
      }
    ],
    "inventory": {
      "quantity": 20
    }
  },
  {
    "gtin": "01000048",
    "name": "Watermelon Soda",
    "brandName": "FizzPop",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 0.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.09,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1755219854/products/pim/5060185372915-1410655206/st-moriz-applikations-handschuh-zur-selbstbraeunung",
    "imageOutline": {
      "x0": 0.2,
      "y0": 0.0,
      "x1": 0.8,
      "y1": 1.0,
      "aspect": 0.6
    },
    "placements": [
      {
        "shelfId": "D0WB",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5f32"
      }
    ],
    "inventory": {
      "quantity": 16
    }
  },
  {
    "gtin": "01000049",
    "name": "Xtra Crunch Chips",
    "brandName": "SnackCo",
    "baseCategory": "Snacks",
    "reportedPrice": {
      "amount": 1.79,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.89,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1750901857/products/pim/4262368741285-54801097/mabyen-baby-wundcreme",
    "imageOutline": {
      "x0": 0.27,
      "y0": 0.0,
      "x1": 0.725,
      "y1": 1.0,
      "aspect": 0.455
    },
    "placements": [
      {
        "shelfId": "3FNR",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5ed7"
      }
    ],
    "inventory": {
      "quantity": 28
    }
  },
  {
    "gtin": "01000050",
    "name": "Yam Fries",
    "brandName": "VeggieBake",
    "baseCategory": "Frozen Foods",
    "reportedPrice": {
      "amount": 2.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1754533961/products/pim/4066447374544-1364358599/balea-abschminktuecher-3in1-erfrischend",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.125,
      "x1": 1.0,
      "y1": 0.875,
      "aspect": 1.3333
    },
    "placements": [
      {
        "shelfId": "DCMY",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5ec2"
      }
    ],
    "inventory": {
      "quantity": 41
    }
  },
  {
    "gtin": "01000051",
    "name": "Apple Cider",
    "brandName": "FreshFarms",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 1.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1746625002/products/pim/4066447231427-3498762/denkmit-allzweckreiniger-fruehlingsmoment",
    "imageOutline": {
      "x0": 0.345,
      "y0": 0.0,
      "x1": 0.655,
      "y1": 1.0,
      "aspect": 0.31
    },
    "placements": [
      {
        "shelfId": "LVPL",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5e8f"
      }
    ],
    "inventory": {
      "quantity": 48
    }
  },
  {
    "gtin": "01000052",
    "name": "Apple Pie",
    "brandName": "SweetTreats",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 3.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745002343/products/pim/4015100864793-1902249105/schauma-conditioner-repair-und-care",
    "imageOutline": {
      "x0": 0.275,
      "y0": 0.0,
      "x1": 0.72,
      "y1": 1.0,
      "aspect": 0.445
    },
    "placements": [
      {
        "shelfId": "IS38",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5efd"
      }
    ],
    "inventory": {
      "quantity": 33
    }
  },
  {
    "gtin": "01000053",
    "name": "Banana Bread",
    "brandName": "CookieJar",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 3.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1747440375/products/pim/42449508-355616148/nivea-men-antitranspirant-deo-roll-on-black-und-white",
    "imageOutline": {
      "x0": 0.31,
      "y0": 0.0,
      "x1": 0.695,
      "y1": 1.0,
      "aspect": 0.385
    },
    "placements": [
      {
        "shelfId": "SQDY",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5eaf"
      }
    ],
    "inventory": {
      "quantity": 5
    }
  },
  {
    "gtin": "01000054",
    "name": "Banana Smoothie",
    "brandName": "SmoothieKing",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 2.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1746439551/products/pim/4067796082357-1856057950/babylove-babysnack-reiswaffeln-sommerfruechte-apfel-ab-dem-8-monat",
    "imageOutline": {
      "x0": 0.015,
      "y0": 0.0,
      "x1": 0.985,
      "y1": 1.0,
      "aspect": 0.97
    },
    "placements": [
      {
        "shelfId": "DCMY",
        "stockLevel": "UNKNOWN",
        "facingId": "679afb3e3d9bab0f83ff606e"
      }
    ],
    "inventory": {
      "quantity": 46
    }
  },
  {
    "gtin": "01000055",
    "name": "Carrot Juice",
    "brandName": "FreshFarms",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 1.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744969351/products/pim/4066447219975-1379106531/dmbio-brotaufstrich-streichcreme-paprika-chili",
    "imageOutline": {
      "x0": 0.11,
      "y0": 0.0,
      "x1": 0.895,
      "y1": 1.0,
      "aspect": 0.785
    },
    "placements": [
      {
        "shelfId": "AA8H",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3e3d9bab0f83ff61ad"
      }
    ],
    "inventory": {
      "quantity": 30
    }
  },
  {
    "gtin": "01000056",
    "name": "Carrot Muffin",
    "brandName": "SweetTreats",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744998905/products/pim/3574661816005-1823653615/penaten-babyoel-intensiv",
    "imageOutline": {
      "x0": 0.275,
      "y0": 0.0,
      "x1": 0.72,
      "y1": 1.0,
      "aspect": 0.445
    },
    "placements": [
      {
        "shelfId": "A4U7",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff61bc"
      }
    ],
    "inventory": {
      "quantity": 49
    }
  },
  {
    "gtin": "01000057",
    "name": "Dairy Yogurt",
    "brandName": "DairyDream",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 0.79,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 0.89,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745000596/products/pim/8720181284366-1709722797/dove-men-care-antitranspirant-deospray-advanced-invisible-dry",
    "imageOutline": {
      "x0": 0.37,
      "y0": 0.0,
      "x1": 0.63,
      "y1": 1.0,
      "aspect": 0.26
    },
    "placements": [
      {
        "shelfId": "F9ZL",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff620a"
      }
    ],
    "inventory": {
      "quantity": 0
    }
  },
  {
    "gtin": "9100000161723",
    "name": "Dairy Cheese",
    "brandName": "MilkyWay",
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744985137/products/pim/4059729438683-28835968/inao-cleanser-exfoliation-feel-pure",
    "imageOutline": {
      "x0": 0.34,
      "y0": 0.0,
      "x1": 0.66,
      "y1": 1.0,
      "aspect": 0.32
    },
    "placements": [
      {
        "shelfId": "N2DT",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6259"
      }
    ],
    "inventory": {
      "quantity": 23
    }
  },
  {
    "gtin": "01000059",
    "name": "Egg Salad",
    "brandName": "HealthyChoice",
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1757638263/products/pim/4066447468076-2096307163/balea-conditioner-intensivpflege",
    "imageOutline": {
      "x0": 0.3,
      "y0": 0.0,
      "x1": 0.695,
      "y1": 1.0,
      "aspect": 0.395
    },
    "placements": [
      {
        "shelfId": "F01K",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff622a"
      }
    ],
    "inventory": {
      "quantity": 16
    }
  },
  {
    "gtin": "01000060",
    "name": "Egg Tart",
    "brandName": "SweetTreats",
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745001602/products/pim/4062700835036-1372514849/nexa-lotte-ameisen-leimfalle",
    "imageOutline": {
      "x0": 0.275,
      "y0": 0.0,
      "x1": 0.73,
      "y1": 1.0,
      "aspect": 0.455
    },
    "placements": [
      {
        "shelfId": "OXVF",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3f3d9bab0f83ff62fa"
      }
    ],
    "inventory": {
      "quantity": 55
    }
  },
  {
    "gtin": "01000061",
    "name": "Apple Cider Vinegar",
    "brandName": "FreshFarms",
    "baseCategory": "Condiments",
    "reportedPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1747308056/products/pim/80830511-1347805107/borotalco-antitranspirant-deospray-original-reisegroesse",
    "imageOutline": {
      "x0": 0.35,
      "y0": 0.0,
      "x1": 0.645,
      "y1": 1.0,
      "aspect": 0.295
    },
    "placements": [
      {
        "shelfId": "ZRKO",
        "stockLevel": "UNKNOWN",
        "facingId": "679afb3f3d9bab0f83ff6301"
      }
    ],
    "inventory": {
      "quantity": 42
    }
  },
  {
    "gtin": "01000062",
    "name": "Apple Sauce",
    "brandName": "FreshFarms",
    "baseCategory": "Canned & Jarred",
    "reportedPrice": {
      "amount": 1.79,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.99,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744986312/products/pim/4045607001018-1788720220/haka-allzweckreiniger-eco-allesreiniger",
    "imageOutline": {
      "x0": 0.325,
      "y0": 0.0,
      "x1": 0.675,
      "y1": 1.0,
      "aspect": 0.35
    },
    "placements": [
      {
        "shelfId": "MKFF",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6318"
      }
    ],
    "inventory": {
      "quantity": 6
    }
  },
  {
    "gtin": "01000063",
    "name": "Apple Tart",
    "brandName": "SweetTreats",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 3.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 4.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1754534084/products/pim/4066447759129-1670689767/dmbio-beluga-linsen",
    "imageOutline": {
      "x0": 0.195,
      "y0": 0.0,
      "x1": 0.8,
      "y1": 1.0,
      "aspect": 0.605
    },
    "placements": [
      {
        "shelfId": "0ZLK",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6325"
      }
    ],
    "inventory": {
      "quantity": 54
    }
  },
  {
    "gtin": "01000064",
    "name": "Apple Chips",
    "brandName": "SnackCo",
    "baseCategory": "Snacks",
    "reportedPrice": {
      "amount": 2.29,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744997476/products/pim/8700216373807-522907576/oral-b-aufsteckbuerste-io-ultimative-reinigung-schwarz",
    "imageOutline": {
      "x0": 0.24,
      "y0": 0.0,
      "x1": 0.755,
      "y1": 1.0,
      "aspect": 0.515
    },
    "placements": [
      {
        "shelfId": "T2D2",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6332"
      }
    ],
    "inventory": {
      "quantity": 4
    }
  },
  {
    "gtin": "01000065",
    "name": "Apple Jam",
    "brandName": "FruitDelight",
    "baseCategory": "Spreads",
    "reportedPrice": {
      "amount": 2.19,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.39,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1748307105/products/pim/8718114202372-1910273888/rexona-antitranspirant-deocreme-maximum-protection-clean-scent",
    "imageOutline": {
      "x0": 0.2,
      "y0": 0.0,
      "x1": 0.795,
      "y1": 1.0,
      "aspect": 0.595
    },
    "placements": [
      {
        "shelfId": "L4QV",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3f3d9bab0f83ff633f"
      }
    ],
    "inventory": {
      "quantity": 59
    }
  },
  {
    "gtin": "01000066",
    "name": "Banana Milkshake",
    "brandName": "SmoothieKing",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 2.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744991779/products/pim/4016249151287-581591400/allos-amaranth-maiswaffeln-rosmarin-und-meersalz",
    "imageOutline": {
      "x0": 0.31,
      "y0": 0.0,
      "x1": 0.69,
      "y1": 1.0,
      "aspect": 0.38
    },
    "placements": [
      {
        "shelfId": "ICHT",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff634c"
      }
    ],
    "inventory": {
      "quantity": 11
    }
  },
  {
    "gtin": "01000067",
    "name": "Banana Pudding",
    "brandName": "SweetTreats",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 1.29,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.39,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744991950/products/pim/4015637007250-454548698/bauck-muehle-backmischung-haferbrot-vollkorn-glutenfrei",
    "imageOutline": {
      "x0": 0.315,
      "y0": 0.0,
      "x1": 0.685,
      "y1": 1.0,
      "aspect": 0.37
    },
    "placements": [
      {
        "shelfId": "IXEY",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6359"
      }
    ],
    "inventory": {
      "quantity": 57
    }
  },
  {
    "gtin": "01000068",
    "name": "Banana Muffin",
    "brandName": "CookieJar",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744994900/products/pim/4005900983534-1624596557/nivea-abschminktuecher-3in1-pflegend",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.185,
      "x1": 0.995,
      "y1": 0.815,
      "aspect": 1.5794
    },
    "placements": [
      {
        "shelfId": "0APM",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6366"
      }
    ],
    "inventory": {
      "quantity": 11
    }
  },
  {
    "gtin": "01000069",
    "name": "Banana Yogurt",
    "brandName": "DairyDream",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 0.89,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 0.99,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745002519/products/pim/4001499969409-253675570/frosch-colorwaschmittel-fluessig-granatapfel",
    "imageOutline": {
      "x0": 0.19,
      "y0": 0.0,
      "x1": 0.815,
      "y1": 1.0,
      "aspect": 0.625
    },
    "placements": [
      {
        "shelfId": "X7I1",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6373"
      }
    ],
    "inventory": {
      "quantity": 40
    }
  },
  {
    "gtin": "01000070",
    "name": "Carrot Soup",
    "brandName": "SoupMaster",
    "baseCategory": "Canned & Jarred",
    "reportedPrice": {
      "amount": 1.89,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.09,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744994302/products/pim/3574661751603-324833656/neutrogena-bodybalsam-intense-repair",
    "imageOutline": {
      "x0": 0.335,
      "y0": 0.0,
      "x1": 0.67,
      "y1": 1.0,
      "aspect": 0.335
    },
    "placements": [
      {
        "shelfId": "WAX7",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6380"
      }
    ],
    "inventory": {
      "quantity": 31
    }
  },
  {
    "gtin": "01000071",
    "name": "Carrot Chips",
    "brandName": "HealthySnacks",
    "baseCategory": "Snacks",
    "reportedPrice": {
      "amount": 2.29,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744983600/products/pim/4006000083698-577427607/nivea-bodylotion-repair-und-care",
    "imageOutline": {
      "x0": 0.325,
      "y0": 0.0,
      "x1": 0.675,
      "y1": 1.0,
      "aspect": 0.35
    },
    "placements": [
      {
        "shelfId": "9BAH",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff638d"
      }
    ],
    "inventory": {
      "quantity": 2
    }
  },
  {
    "gtin": "01000072",
    "name": "Carrot Bread",
    "brandName": "VeggieBake",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 3.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745411585/products/pim/4066447716689-1480922640/profissimo-allzwecktuecher",
    "imageOutline": {
      "x0": 0.02,
      "y0": 0.0,
      "x1": 0.975,
      "y1": 1.0,
      "aspect": 0.955
    },
    "placements": [
      {
        "shelfId": "KR6V",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff639a"
      }
    ],
    "inventory": {
      "quantity": 36
    }
  },
  {
    "gtin": "01000073",
    "name": "Dairy Cream",
    "brandName": "MilkyWay",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 1.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1750986824/products/pim/9120082226899-2056715774/spirit-cherry-blossom-eau-de-parfum",
    "imageOutline": {
      "x0": 0.165,
      "y0": 0.0,
      "x1": 0.84,
      "y1": 1.0,
      "aspect": 0.675
    },
    "placements": [
      {
        "shelfId": "KNRE",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff63a7"
      }
    ],
    "inventory": {
      "quantity": 52
    }
  },
  {
    "gtin": "01000074",
    "name": "Dairy Ice Cream",
    "brandName": "CoolTreats",
    "baseCategory": "Frozen Foods",
    "reportedPrice": {
      "amount": 4.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 5.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1747875984/products/pim/42449942-655523720/hidrofugal-antitranspirant-deo-roll-on-men-frisch-und-stark",
    "imageOutline": {
      "x0": 0.32,
      "y0": 0.0,
      "x1": 0.685,
      "y1": 1.0,
      "aspect": 0.365
    },
    "placements": [
      {
        "shelfId": "RV6G",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff63b4"
      }
    ],
    "inventory": {
      "quantity": 56
    }
  },
  {
    "gtin": "01000075",
    "name": "Dairy Butter",
    "brandName": "MilkyWay",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 2.29,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744994008/products/pim/4003573289021-1465753882/schaebens-aloe-vera-trink-gel",
    "imageOutline": {
      "x0": 0.32,
      "y0": 0.0,
      "x1": 0.685,
      "y1": 1.0,
      "aspect": 0.365
    },
    "placements": [
      {
        "shelfId": "PED2",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff63c1"
      }
    ],
    "inventory": {
      "quantity": 21
    }
  },
  {
    "gtin": "01000076",
    "name": "Egg Sandwich",
    "brandName": "HealthyChoice",
    "baseCategory": "Sandwiches",
    "reportedPrice": {
      "amount": 3.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744996005/products/pim/4018852029359-1743843223/bebivita-abendbrei-keks-banane-ab-dem-6-monat",
    "imageOutline": {
      "x0": 0.19,
      "y0": 0.0,
      "x1": 0.81,
      "y1": 1.0,
      "aspect": 0.62
    },
    "placements": [
      {
        "shelfId": "8CS4",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff63ce"
      }
    ],
    "inventory": {
      "quantity": 57
    }
  },
  {
    "gtin": "01000077",
    "name": "Egg Fried Rice",
    "brandName": "NoodleNest",
    "baseCategory": "Frozen Foods",
    "reportedPrice": {
      "amount": 2.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744982449/products/pim/4251099705864-1117150364/alete-bewusst-abendbrei-griessbrei-vanille-und-vollkorn-ab-dem-6-monat",
    "imageOutline": {
      "x0": 0.205,
      "y0": 0.0,
      "x1": 0.795,
      "y1": 1.0,
      "aspect": 0.59
    },
    "placements": [
      {
        "shelfId": "2XNU",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff63db"
      }
    ],
    "inventory": {
      "quantity": 2
    }
  },
  {
    "gtin": "01000078",
    "name": "Egg Pasta",
    "brandName": "NoodleNest",
    "baseCategory": "Pasta & Noodles",
    "reportedPrice": {
      "amount": 1.89,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.09,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745002519/products/pim/4001499969409-253675570/frosch-colorwaschmittel-fluessig-granatapfel",
    "imageOutline": {
      "x0": 0.19,
      "y0": 0.0,
      "x1": 0.815,
      "y1": 1.0,
      "aspect": 0.625
    },
    "placements": [
      {
        "shelfId": "8MXE",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff63e8"
      }
    ],
    "inventory": {
      "quantity": 53
    }
  },
  {
    "gtin": "01000079",
    "name": "Chocolate Chip Cookies",
    "brandName": "CookieJar",
    "baseCategory": "Sweets & Confectionery",
    "reportedPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744985176/products/pim/7610700946541-1611986516/ricola-bonbon-cranberry-zuckerfrei-in-der-taschenbox",
    "imageOutline": {
      "x0": 0.165,
      "y0": 0.0,
      "x1": 0.835,
      "y1": 1.0,
      "aspect": 0.67
    },
    "placements": [
      {
        "shelfId": "X08Z",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff63f5"
      }
    ],
    "inventory": {
      "quantity": 32
    }
  },
  {
    "gtin": "01000080",
    "name": "Chocolate Milk",
    "brandName": "MilkyWay",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 1.29,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.39,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744982449/products/pim/4251099705864-1117150364/alete-bewusst-abendbrei-griessbrei-vanille-und-vollkorn-ab-dem-6-monat",
    "imageOutline": {
      "x0": 0.205,
      "y0": 0.0,
      "x1": 0.795,
      "y1": 1.0,
      "aspect": 0.59
    },
    "placements": [
      {
        "shelfId": "K35A",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6402"
      }
    ],
    "inventory": {
      "quantity": 42
    }
  },
  {
    "gtin": "01000081",
    "name": "Chocolate Cake",
    "brandName": "SweetTreats",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 4.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 4.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744969594/products/pim/4066447486193-340107002/dmbio-brotaufstrich-saatenaufstrich-paprika-und-hanf",
    "imageOutline": {
      "x0": 0.09,
      "y0": 0.0,
      "x1": 0.905,
      "y1": 1.0,
      "aspect": 0.815
    },
    "placements": [
      {
        "shelfId": "PZXD",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff640f"
      }
    ],
    "inventory": {
      "quantity": 18
    }
  },
  {
    "gtin": "01000082",
    "name": "Chocolate Bar",
    "brandName": "CandyLand",
    "baseCategory": "Sweets & Confectionery",
    "reportedPrice": {
      "amount": 1.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744980954/products/pim/4066447709889-1906462775/babylove-baby-koerperlotion-ultra-sensitive",
    "imageOutline": {
      "x0": 0.315,
      "y0": 0.0,
      "x1": 0.68,
      "y1": 1.0,
      "aspect": 0.365
    },
    "placements": [
      {
        "shelfId": "2R5C",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff641c"
      }
    ],
    "inventory": {
      "quantity": 40
    }
  },
  {
    "gtin": "01000083",
    "name": "Chocolate Ice Cream",
    "brandName": "CoolTreats",
    "baseCategory": "Frozen Foods",
    "reportedPrice": {
      "amount": 4.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 5.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744994544/products/pim/4260133239104-2073745385/fruchtbar-babyloeffel-fuer-quetschbeutel-ab-dem-6-monat",
    "imageOutline": {
      "x0": 0.22,
      "y0": 0.0,
      "x1": 0.785,
      "y1": 1.0,
      "aspect": 0.565
    },
    "placements": [
      {
        "shelfId": "X7BX",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6429"
      }
    ],
    "inventory": {
      "quantity": 50
    }
  },
  {
    "gtin": "01000084",
    "name": "Strawberry Smoothie",
    "brandName": "SmoothieKing",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 2.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1747721796/products/pim/4066447789911-1180389074/denkmit-backofen-und-grillreiniger-mit-aktiv-schaum",
    "imageOutline": {
      "x0": 0.37,
      "y0": 0.0,
      "x1": 0.63,
      "y1": 1.0,
      "aspect": 0.26
    },
    "placements": [
      {
        "shelfId": "83ZI",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6436"
      }
    ],
    "inventory": {
      "quantity": 17
    }
  },
  {
    "gtin": "01000085",
    "name": "Strawberry Cake",
    "brandName": "SweetTreats",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 4.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 4.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745000132/products/pim/4210201299813-442291234/oral-b-aufsteckbuersten-pulsonic-clean-vorteilspack",
    "imageOutline": {
      "x0": 0.365,
      "y0": 0.0,
      "x1": 0.635,
      "y1": 1.0,
      "aspect": 0.27
    },
    "placements": [
      {
        "shelfId": "MUZ4",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6443"
      }
    ],
    "inventory": {
      "quantity": 54
    }
  },
  {
    "gtin": "01000086",
    "name": "Strawberry Yogurt",
    "brandName": "DairyDream",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 0.89,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 0.99,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1755907677/products/pim/4062300321335-1598776057/hipp-abendbrei-gute-nacht-dinkelgriess-ab-dem-6-monat",
    "imageOutline": {
      "x0": 0.175,
      "y0": 0.0,
      "x1": 0.82,
      "y1": 1.0,
      "aspect": 0.645
    },
    "placements": [
      {
        "shelfId": "OFVB",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6450"
      }
    ],
    "inventory": {
      "quantity": 20
    }
  },
  {
    "gtin": "01000087",
    "name": "Strawberry Ice Cream",
    "brandName": "CoolTreats",
    "baseCategory": "Frozen Foods",
    "reportedPrice": {
      "amount": 4.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 5.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745001512/products/pim/8720689036900-1149228168/philips-sonicare-aufsteckbuersten-w2-optimalwhite-schwarz",
    "imageOutline": {
      "x0": 0.37,
      "y0": 0.0,
      "x1": 0.63,
      "y1": 1.0,
      "aspect": 0.26
    },
    "placements": [
      {
        "shelfId": "ACMA",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff645d"
      }
    ],
    "inventory": {
      "quantity": 22
    }
  },
  {
    "gtin": "01000088",
    "name": "Organic Apple Juice",
    "brandName": "FreshFarms",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744995803/products/pim/4058172823084-426231248/balea-men-augen-roll-on-energy",
    "imageOutline": {
      "x0": 0.135,
      "y0": 0.0,
      "x1": 0.86,
      "y1": 1.0,
      "aspect": 0.725
    },
    "placements": [
      {
        "shelfId": "O9AI",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff646a"
      }
    ],
    "inventory": {
      "quantity": 25
    }
  },
  {
    "gtin": "01000089",
    "name": "Green Apple Soda",
    "brandName": "FizzPop",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 0.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.09,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744974220/products/pim/4042441017472-1006367285/balea-blasenpflaster-mix",
    "imageOutline": {
      "x0": 0.18,
      "y0": 0.0,
      "x1": 0.825,
      "y1": 1.0,
      "aspect": 0.645
    },
    "placements": [
      {
        "shelfId": "12YG",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6477"
      }
    ],
    "inventory": {
      "quantity": 31
    }
  },
  {
    "gtin": "01000090",
    "name": "Red Apple Chips",
    "brandName": "HealthySnacks",
    "baseCategory": "Snacks",
    "reportedPrice": {
      "amount": 2.29,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744979571/products/pim/4066447715620-1493898782/balea-badepuder-have-a-berry-good-day",
    "imageOutline": {
      "x0": 0.235,
      "y0": 0.0,
      "x1": 0.765,
      "y1": 1.0,
      "aspect": 0.53
    },
    "placements": [
      {
        "shelfId": "8FV1",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6484"
      }
    ],
    "inventory": {
      "quantity": 54
    }
  },
  {
    "gtin": "01000091",
    "name": "Vanilla Ice Cream",
    "brandName": "CoolTreats",
    "baseCategory": "Frozen Foods",
    "reportedPrice": {
      "amount": 4.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 5.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744983535/products/pim/4008137009312-990918173/bad-heilbrunner-arzneitee-husten-und-bronchial-tee-12-beutel",
    "imageOutline": {
      "x0": 0.135,
      "y0": 0.0,
      "x1": 0.865,
      "y1": 1.0,
      "aspect": 0.73
    },
    "placements": [
      {
        "shelfId": "USE9",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6491"
      }
    ],
    "inventory": {
      "quantity": 13
    }
  },
  {
    "gtin": "01000092",
    "name": "Vanilla Cake",
    "brandName": "SweetTreats",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 4.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 4.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744996226/products/pim/4066447506280-1516224752/balea-men-after-shave-balsam-energy",
    "imageOutline": {
      "x0": 0.205,
      "y0": 0.0,
      "x1": 0.795,
      "y1": 1.0,
      "aspect": 0.59
    },
    "placements": [
      {
        "shelfId": "CCLK",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff649e"
      }
    ],
    "inventory": {
      "quantity": 55
    }
  },
  {
    "gtin": "01000093",
    "name": "Vanilla Yogurt",
    "brandName": "DairyDream",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 0.89,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 0.99,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744817441/products/pim/4066447373189-3827799/dmbio-braune-linsen",
    "imageOutline": {
      "x0": 0.195,
      "y0": 0.0,
      "x1": 0.805,
      "y1": 1.0,
      "aspect": 0.61
    },
    "placements": [
      {
        "shelfId": "FZPF",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff64ab"
      }
    ],
    "inventory": {
      "quantity": 48
    }
  },
  {
    "gtin": "01000094",
    "name": "Vanilla Cookies",
    "brandName": "CookieJar",
    "baseCategory": "Sweets & Confectionery",
    "reportedPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744980050/products/pim/4008617138822-1009462392/klosterfrau-arnika-intensiv-creme",
    "imageOutline": {
      "x0": 0.34,
      "y0": 0.0,
      "x1": 0.66,
      "y1": 1.0,
      "aspect": 0.32
    },
    "placements": [
      {
        "shelfId": "YY8P",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff64b8"
      }
    ],
    "inventory": {
      "quantity": 41
    }
  },
  {
    "gtin": "01000095",
    "name": "Mixed Berry Juice",
    "brandName": "FreshFarms",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 2.29,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744816688/products/pim/4036581536054-3746809/sheko-abnehmkur-sticks-21-st",
    "imageOutline": {
      "x0": 0.165,
      "y0": 0.0,
      "x1": 0.835,
      "y1": 1.0,
      "aspect": 0.67
    },
    "placements": [
      {
        "shelfId": "7VS8",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff64c5"
      }
    ],
    "inventory": {
      "quantity": 32
    }
  },
  {
    "gtin": "01000096",
    "name": "Berry Muffin",
    "brandName": "CookieJar",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744998713/products/pim/4006000131467-926683978/hidrofugal-antitranspirant-deospray-men-frisch-und-stark",
    "imageOutline": {
      "x0": 0.37,
      "y0": 0.0,
      "x1": 0.635,
      "y1": 1.0,
      "aspect": 0.265
    },
    "placements": [
      {
        "shelfId": "GI4V",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff64d2"
      }
    ],
    "inventory": {
      "quantity": 19
    }
  },
  {
    "gtin": "01000097",
    "name": "Berry Yogurt",
    "brandName": "DairyDream",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 0.89,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 0.99,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744982530/products/pim/8712561820899-556092284/dove-antitranspirant-deospray-powder-soft",
    "imageOutline": {
      "x0": 0.37,
      "y0": 0.01,
      "x1": 0.635,
      "y1": 1.0,
      "aspect": 0.2677
    },
    "placements": [
      {
        "shelfId": "T6G8",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff64df"
      }
    ],
    "inventory": {
      "quantity": 21
    }
  },
  {
    "gtin": "01000098",
    "name": "Berry Pie",
    "brandName": "SweetTreats",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 4.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 4.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1747307938/products/pim/3574661651675-1292649377/neutrogena-anti-age-augencreme-retinol-boost",
    "imageOutline": {
      "x0": 0.13,
      "y0": 0.0,
      "x1": 0.865,
      "y1": 1.0,
      "aspect": 0.735
    },
    "placements": [
      {
        "shelfId": "JGU7",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff64ec"
      }
    ],
    "inventory": {
      "quantity": 1
    }
  },
  {
    "gtin": "01000099",
    "name": "Milk Chocolate",
    "brandName": "CandyLand",
    "baseCategory": "Sweets & Confectionery",
    "reportedPrice": {
      "amount": 1.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1749861739/products/pim/4062300470187-1639513820/hipp-baby-pants-gr-6-14-kg",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.09,
      "x1": 1.0,
      "y1": 0.91,
      "aspect": 1.2195
    },
    "placements": [
      {
        "shelfId": "H9YO",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff64f9"
      }
    ],
    "inventory": {
      "quantity": 54
    }
  },
  {
    "gtin": "01000100",
    "name": "Milk Powder",
    "brandName": "MilkyWay",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 3.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744994155/products/pim/4066447668674-2104359515/babylove-baby-pants-premium-gr-8-19-kg",
    "imageOutline": {
      "x0": 0.155,
      "y0": 0.0,
      "x1": 0.84,
      "y1": 1.0,
      "aspect": 0.685
    },
    "placements": [
      {
        "shelfId": "U0ES",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6506"
      }
    ],
    "inventory": {
      "quantity": 7
    }
  },
  {
    "gtin": "01000101",
    "name": "Coconut Milk",
    "brandName": "TropicalTaste",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 1.79,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.99,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1758073390/products/pim/4001638590235-752613694/weleda-baby-calendula-wundschutzcreme-parfuemfrei",
    "imageOutline": {
      "x0": 0.175,
      "y0": 0.05,
      "x1": 0.825,
      "y1": 1.0,
      "aspect": 0.6842
    },
    "placements": [
      {
        "shelfId": "VBK4",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6513"
      }
    ],
    "inventory": {
      "quantity": 56
    }
  },
  {
    "gtin": "01000102",
    "name": "Coconut Cookies",
    "brandName": "CookieJar",
    "baseCategory": "Sweets & Confectionery",
    "reportedPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744994421/products/pim/3600523428045-867010167/l-oreal-paris-anti-falten-nachtcreme-experte-65",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.2,
      "x1": 1.0,
      "y1": 0.805,
      "aspect": 1.6529
    },
    "placements": [
      {
        "shelfId": "DEZN",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6520"
      }
    ],
    "inventory": {
      "quantity": 22
    }
  },
  {
    "gtin": "01000103",
    "name": "Coconut Cake",
    "brandName": "SweetTreats",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 4.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 4.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744816732/products/pim/4066447212129-3748420/mivolis-arzneitee-brennnessel-tee-12-beutel",
    "imageOutline": {
      "x0": 0.005,
      "y0": 0.0,
      "x1": 0.995,
      "y1": 1.0,
      "aspect": 0.99
    },
    "placements": [
      {
        "shelfId": "3WYZ",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff652d"
      }
    ],
    "inventory": {
      "quantity": 42
    }
  },
  {
    "gtin": "01000104",
    "name": "Coconut Ice Cream",
    "brandName": "CoolTreats",
    "baseCategory": "Frozen Foods",
    "reportedPrice": {
      "amount": 4.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 5.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744997730/products/pim/4066447438413-2131253223/balea-2in1-fussschutz-und-deo-spray",
    "imageOutline": {
      "x0": 0.375,
      "y0": 0.0,
      "x1": 0.63,
      "y1": 1.0,
      "aspect": 0.255
    },
    "placements": [
      {
        "shelfId": "SCAP",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff653a"
      }
    ],
    "inventory": {
      "quantity": 32
    }
  },
  {
    "gtin": "01000105",
    "name": "Lemon Juice",
    "brandName": "FreshFarms",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 1.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744963491/products/pim/3600524055721-129095146/l-oreal-paris-revitalift-anti-age-nachtcreme-revitalift-laser-x3",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.16,
      "x1": 1.0,
      "y1": 0.835,
      "aspect": 1.4815
    },
    "placements": [
      {
        "shelfId": "IFRD",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6547"
      }
    ],
    "inventory": {
      "quantity": 4
    }
  },
  {
    "gtin": "01000106",
    "name": "Lemon Cake",
    "brandName": "SweetTreats",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 4.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 4.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745454104/products/pim/4036581252886-1950112390/zirkulin-biotix-kulturen-komplex-kapseln-28-st",
    "imageOutline": {
      "x0": 0.285,
      "y0": 0.0,
      "x1": 0.71,
      "y1": 1.0,
      "aspect": 0.425
    },
    "placements": [
      {
        "shelfId": "UJGZ",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6554"
      }
    ],
    "inventory": {
      "quantity": 29
    }
  },
  {
    "gtin": "01000107",
    "name": "Lemon Cookies",
    "brandName": "CookieJar",
    "baseCategory": "Sweets & Confectionery",
    "reportedPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1747307598/products/pim/9005800379227-982780705/nivea-men-antitranspirant-deospray-alpine-breeze",
    "imageOutline": {
      "x0": 0.365,
      "y0": 0.0,
      "x1": 0.63,
      "y1": 1.0,
      "aspect": 0.265
    },
    "placements": [
      {
        "shelfId": "QC7U",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6561"
      }
    ],
    "inventory": {
      "quantity": 42
    }
  },
  {
    "gtin": "01000108",
    "name": "Orange Cake",
    "brandName": "SweetTreats",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 4.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 4.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744817051/products/pim/4015537002348-3797673/hammermuehle-brot-5-saatenbrot-simply-seeds-glutenfrei-4-stueck",
    "imageOutline": {
      "x0": 0.065,
      "y0": 0.0,
      "x1": 0.935,
      "y1": 1.0,
      "aspect": 0.87
    },
    "placements": [
      {
        "shelfId": "U0DC",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff656e"
      }
    ],
    "inventory": {
      "quantity": 57
    }
  },
  {
    "gtin": "01000109",
    "name": "Orange Cookies",
    "brandName": "CookieJar",
    "baseCategory": "Sweets & Confectionery",
    "reportedPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744994421/products/pim/3600523428045-867010167/l-oreal-paris-anti-falten-nachtcreme-experte-65",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.2,
      "x1": 1.0,
      "y1": 0.805,
      "aspect": 1.6529
    },
    "placements": [
      {
        "shelfId": "4LJV",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff657b"
      }
    ],
    "inventory": {
      "quantity": 3
    }
  },
  {
    "gtin": "01000110",
    "name": "Orange Yogurt",
    "brandName": "DairyDream",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 0.89,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 0.99,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745005756/products/pim/8700216595773-1838191751/pampers-baby-pants-baby-dry-gr-5-junior-11-17-kg-big-pack",
    "imageOutline": {
      "x0": 0.28,
      "y0": 0.0,
      "x1": 0.725,
      "y1": 1.0,
      "aspect": 0.445
    },
    "placements": [
      {
        "shelfId": "7YSF",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6588"
      }
    ],
    "inventory": {
      "quantity": 47
    }
  },
  {
    "gtin": "01000111",
    "name": "Orange Soda",
    "brandName": "FizzPop",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 0.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.09,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744981606/products/pim/4066447710144-2080378097/babylove-baby-badezusatz-entspannendes-schlaf-schoen-bad-sensitive",
    "imageOutline": {
      "x0": 0.325,
      "y0": 0.0,
      "x1": 0.675,
      "y1": 1.0,
      "aspect": 0.35
    },
    "placements": [
      {
        "shelfId": "8SMF",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6595"
      }
    ],
    "inventory": {
      "quantity": 2
    }
  },
  {
    "gtin": "01000112",
    "name": "Fruit Salad",
    "brandName": "HealthyChoice",
    "baseCategory": "Salads",
    "reportedPrice": {
      "amount": 3.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 4.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745001825/products/pim/4056631001202-478742424/aptamil-anfangsmilch-pre-pronutra-von-geburt-an",
    "imageOutline": {
      "x0": 0.19,
      "y0": 0.0,
      "x1": 0.81,
      "y1": 1.0,
      "aspect": 0.62
    },
    "placements": [
      {
        "shelfId": "ZQ0I",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff65a2"
      }
    ],
    "inventory": {
      "quantity": 49
    }
  },
  {
    "gtin": "01000113",
    "name": "Fruit Cake",
    "brandName": "SweetTreats",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 4.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 4.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1747875592/products/pim/4066447767223-1144599058/profissimo-badtuch-2in1",
    "imageOutline": {
      "x0": 0.25,
      "y0": 0.0,
      "x1": 0.75,
      "y1": 1.0,
      "aspect": 0.5
    },
    "placements": [
      {
        "shelfId": "5XWF",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff65af"
      }
    ],
    "inventory": {
      "quantity": 9
    }
  },
  {
    "gtin": "01000114",
    "name": "Fruit Smoothie",
    "brandName": "SmoothieKing",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 2.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744974561/products/pim/742042736133-1967471171/shield-n-bettwanzenspray",
    "imageOutline": {
      "x0": 0.3,
      "y0": 0.0,
      "x1": 0.7,
      "y1": 1.0,
      "aspect": 0.4
    },
    "placements": [
      {
        "shelfId": "U4OH",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff65bc"
      }
    ],
    "inventory": {
      "quantity": 0
    }
  },
  {
    "gtin": "01000115",
    "name": "Fruit Yogurt",
    "brandName": "DairyDream",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 0.89,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 0.99,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744998302/products/pim/8700216670647-1739650939/pampers-baby-pants-baby-dry-gr-7-xl-15-kg",
    "imageOutline": {
      "x0": 0.135,
      "y0": 0.0,
      "x1": 0.86,
      "y1": 1.0,
      "aspect": 0.725
    },
    "placements": [
      {
        "shelfId": "5XUT",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff65c9"
      }
    ],
    "inventory": {
      "quantity": 4
    }
  },
  {
    "gtin": "01000116",
    "name": "Tropical Fruit Juice",
    "brandName": "TropicalTaste",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 2.29,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1748996729/products/pim/4013182023831-1776916400/nabio-brotaufstrich-paprika-feta-olive",
    "imageOutline": {
      "x0": 0.075,
      "y0": 0.0,
      "x1": 0.92,
      "y1": 1.0,
      "aspect": 0.845
    },
    "placements": [
      {
        "shelfId": "KP5H",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff65d6"
      }
    ],
    "inventory": {
      "quantity": 45
    }
  },
  {
    "gtin": "01000117",
    "name": "Chocolate Smoothie",
    "brandName": "SmoothieKing",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 2.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744747073/products/pim/4058172623714-2300518/babylove-abendbrei-griess-pur-ab-dem-5-monat",
    "imageOutline": {
      "x0": 0.235,
      "y0": 0.0,
      "x1": 0.77,
      "y1": 1.0,
      "aspect": 0.535
    },
    "placements": [
      {
        "shelfId": "CZR6",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff65e3"
      }
    ],
    "inventory": {
      "quantity": 27
    }
  },
  {
    "gtin": "01000118",
    "name": "Chocolate Muffin",
    "brandName": "CookieJar",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744979989/products/pim/4067796014280-628472255/dmbio-bliss-balls-nuss-nougatfuellung",
    "imageOutline": {
      "x0": 0.31,
      "y0": 0.0,
      "x1": 0.695,
      "y1": 1.0,
      "aspect": 0.385
    },
    "placements": [
      {
        "shelfId": "O99O",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff65f0"
      }
    ],
    "inventory": {
      "quantity": 11
    }
  },
  {
    "gtin": "01000119",
    "name": "Chocolate Pudding",
    "brandName": "SweetTreats",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 1.29,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.39,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744997410/products/pim/4008508464009-2117339240/spontex-badputzer-badspons",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.205,
      "x1": 1.0,
      "y1": 0.79,
      "aspect": 1.7094
    },
    "placements": [
      {
        "shelfId": "U85I",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff65fd"
      }
    ],
    "inventory": {
      "quantity": 41
    }
  },
  {
    "gtin": "01000120",
    "name": "Chocolate Yogurt",
    "brandName": "DairyDream",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 0.89,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 0.99,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744996021/products/pim/8445291643635-933445807/nestle-beba-anfangsmilch-pre-von-geburt-an",
    "imageOutline": {
      "x0": 0.18,
      "y0": 0.0,
      "x1": 0.825,
      "y1": 1.0,
      "aspect": 0.645
    },
    "placements": [
      {
        "shelfId": "J55R",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff660a"
      }
    ],
    "inventory": {
      "quantity": 3
    }
  },
  {
    "gtin": "01000121",
    "name": "Pineapple Juice",
    "brandName": "TropicalTaste",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 2.29,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744981958/products/pim/4015001014143-12905410/diadermine-anti-falten-gesichtscreme-age-supreme-falten-expert-3d",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.025,
      "x1": 1.0,
      "y1": 0.975,
      "aspect": 1.0526
    },
    "placements": [
      {
        "shelfId": "X8IJ",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6617"
      }
    ],
    "inventory": {
      "quantity": 6
    }
  },
  {
    "gtin": "01000122",
    "name": "Pineapple Cake",
    "brandName": "SweetTreats",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 4.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 4.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744982024/products/pim/59083856-141800730/dove-antitranspirant-deo-roll-on-advanced-care-invisible-dry",
    "imageOutline": {
      "x0": 0.305,
      "y0": 0.0,
      "x1": 0.69,
      "y1": 1.0,
      "aspect": 0.385
    },
    "placements": [
      {
        "shelfId": "U0JR",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6624"
      }
    ],
    "inventory": {
      "quantity": 21
    }
  },
  {
    "gtin": "01000123",
    "name": "Pineapple Rings",
    "brandName": "TropicalTaste",
    "baseCategory": "Canned & Jarred",
    "reportedPrice": {
      "amount": 1.89,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.09,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744999054/products/pim/8700216678384-453297811/ariel-colorwaschmittel-pods",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.035,
      "x1": 1.0,
      "y1": 0.96,
      "aspect": 1.0811
    },
    "placements": [
      {
        "shelfId": "XKQG",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6631"
      }
    ],
    "inventory": {
      "quantity": 23
    }
  },
  {
    "gtin": "01000124",
    "name": "Pineapple Pizza",
    "brandName": "ItalianEats",
    "baseCategory": "Frozen Foods",
    "reportedPrice": {
      "amount": 5.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 6.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744963277/products/pim/4262365714084-890421562/everdrop-badreiniger-nachfuellpack-fuer-450ml",
    "imageOutline": {
      "x0": 0.155,
      "y0": 0.0,
      "x1": 0.845,
      "y1": 1.0,
      "aspect": 0.69
    },
    "placements": [
      {
        "shelfId": "ASLY",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff663e"
      }
    ],
    "inventory": {
      "quantity": 42
    }
  },
  {
    "gtin": "01000125",
    "name": "Snapper Fish",
    "brandName": "SeaFresh",
    "baseCategory": "Seafood",
    "reportedPrice": {
      "amount": 8.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 9.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745001552/products/pim/8700216679381-1520439350/pampers-baby-pants-premium-protection-gr-6-xl-13-19kg-big-pack",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.055,
      "x1": 1.0,
      "y1": 0.945,
      "aspect": 1.1236
    },
    "placements": [
      {
        "shelfId": "V5ZY",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff664b"
      }
    ],
    "inventory": {
      "quantity": 48
    }
  },
  {
    "gtin": "01000126",
    "name": "Cappuccino Mix",
    "brandName": "CoffeeLovers",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 3.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744980898/products/pim/4066447710083-413034/babylove-baby-kopf-bis-fuss-waschgel-nachfuellpack",
    "imageOutline": {
      "x0": 0.215,
      "y0": 0.005,
      "x1": 0.79,
      "y1": 1.0,
      "aspect": 0.5779
    },
    "placements": [
      {
        "shelfId": "6SBB",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6658"
      }
    ],
    "inventory": {
      "quantity": 45
    }
  },
  {
    "gtin": "01000127",
    "name": "Cappuccino Cookies",
    "brandName": "CookieJar",
    "baseCategory": "Sweets & Confectionery",
    "reportedPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744999750/products/pim/8720181343452-1643482702/axe-after-shave-alaska",
    "imageOutline": {
      "x0": 0.31,
      "y0": 0.0,
      "x1": 0.69,
      "y1": 1.0,
      "aspect": 0.38
    },
    "placements": [
      {
        "shelfId": "K3DS",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6665"
      }
    ],
    "inventory": {
      "quantity": 8
    }
  },
  {
    "gtin": "01000128",
    "name": "Appetite Suppressant",
    "brandName": "HealthyLife",
    "baseCategory": "Health & Wellness",
    "reportedPrice": {
      "amount": 12.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 13.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744985435/products/pim/3574661817071-1957785809/penaten-baby-badezusatz-bad-und-shampoo-intensiv",
    "imageOutline": {
      "x0": 0.27,
      "y0": 0.0,
      "x1": 0.735,
      "y1": 1.0,
      "aspect": 0.465
    },
    "placements": [
      {
        "shelfId": "K71R",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6672"
      }
    ],
    "inventory": {
      "quantity": 48
    }
  },
  {
    "gtin": "01000129",
    "name": "Snappy Crackers",
    "brandName": "SnackCo",
    "baseCategory": "Snacks",
    "reportedPrice": {
      "amount": 1.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745002934/products/pim/42449836-538122927/nivea-care-creme-sensitive",
    "imageOutline": {
      "x0": 0.01,
      "y0": 0.095,
      "x1": 1.0,
      "y1": 0.905,
      "aspect": 1.2222
    },
    "placements": [
      {
        "shelfId": "XXBG",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff667f"
      }
    ],
    "inventory": {
      "quantity": 26
    }
  },
  {
    "gtin": "01000130",
    "name": "Happy Meal",
    "brandName": "KidsChoice",
    "baseCategory": "Frozen Foods",
    "reportedPrice": {
      "amount": 4.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 5.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1746066629/products/pim/4001638590358-1499247602/weleda-arnika-salbe-10-prozent",
    "imageOutline": {
      "x0": 0.25,
      "y0": 0.0,
      "x1": 0.75,
      "y1": 1.0,
      "aspect": 0.5
    },
    "placements": [
      {
        "shelfId": "E0W2",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff668c"
      }
    ],
    "inventory": {
      "quantity": 40
    }
  },
  {
    "gtin": "01000131",
    "name": "App Store Gift Card",
    "brandName": "TechGifts",
    "baseCategory": "Gift Cards",
    "reportedPrice": {
      "amount": 25,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 25,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1755130029/products/pim/4011448001104-761711982/kaufm-creme-baby-und-kinder-pflegecreme",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.005,
      "x1": 1.0,
      "y1": 1.0,
      "aspect": 1.005
    },
    "placements": [
      {
        "shelfId": "HVVZ",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6699"
      }
    ],
    "inventory": {
      "quantity": 55
    }
  },
  {
    "gtin": "01000132",
    "name": "Whipped Cream",
    "brandName": "DairyDream",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 1.89,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.09,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1758243437/products/pim/4003573189093-1715503154/schaebens-bitterstoffe-sofort-spray",
    "imageOutline": {
      "x0": 0.32,
      "y0": 0.0,
      "x1": 0.68,
      "y1": 1.0,
      "aspect": 0.36
    },
    "placements": [
      {
        "shelfId": "JCBY",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff66a6"
      }
    ],
    "inventory": {
      "quantity": 29
    }
  },
  {
    "gtin": "01000133",
    "name": "Wrapper Paper",
    "brandName": "GiftWrap",
    "baseCategory": "Household",
    "reportedPrice": {
      "amount": 2.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744973161/products/pim/4066447429121-1900720101/balea-augen-make-up-entferner-oelfrei",
    "imageOutline": {
      "x0": 0.31,
      "y0": 0.0,
      "x1": 0.695,
      "y1": 1.0,
      "aspect": 0.385
    },
    "placements": [
      {
        "shelfId": "II59",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff66b3"
      }
    ],
    "inventory": {
      "quantity": 35
    }
  },
  {
    "gtin": "01000134",
    "name": "Applesauce Cups",
    "brandName": "FreshFarms",
    "baseCategory": "Canned & Jarred",
    "reportedPrice": {
      "amount": 3.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1754533961/products/pim/4066447374544-1364358599/balea-abschminktuecher-3in1-erfrischend",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.125,
      "x1": 1.0,
      "y1": 0.875,
      "aspect": 1.3333
    },
    "placements": [
      {
        "shelfId": "4N8Z",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff66c0"
      }
    ],
    "inventory": {
      "quantity": 38
    }
  },
  {
    "gtin": "01000135",
    "name": "Grappa Liqueur",
    "brandName": "ItalianSpirits",
    "baseCategory": "Alcoholic Beverages",
    "reportedPrice": {
      "amount": 24.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 25.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1748394962/products/pim/4056631003879-1043270438/aptamil-anfangsmilch-1-pronutra-von-geburt-an",
    "imageOutline": {
      "x0": 0.15,
      "y0": 0.0,
      "x1": 0.85,
      "y1": 1.0,
      "aspect": 0.7
    },
    "placements": [
      {
        "shelfId": "T80E",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff66cd"
      }
    ],
    "inventory": {
      "quantity": 42
    }
  },
  {
    "gtin": "01000136",
    "name": "Trapped in Paradise Book",
    "brandName": "BookWorld",
    "baseCategory": "Books & Media",
    "reportedPrice": {
      "amount": 9.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 10.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744998253/products/pim/8700216678445-788450549/ariel-colorwaschmittel-pods",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.21,
      "x1": 1.0,
      "y1": 0.79,
      "aspect": 1.7241
    },
    "placements": [
      {
        "shelfId": "OTUP",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff66da"
      }
    ],
    "inventory": {
      "quantity": 20
    }
  },
  {
    "gtin": "01000137",
    "name": "Happy Snacks Mix",
    "brandName": "PartyTime",
    "baseCategory": "Snacks",
    "reportedPrice": {
      "amount": 3.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 4.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744994570/products/pim/4260133232341-569160761/fruchtbar-babysnack-knusper-brezeln-mais-und-karotte-ab-6-monaten",
    "imageOutline": {
      "x0": 0.185,
      "y0": 0.0,
      "x1": 0.815,
      "y1": 1.0,
      "aspect": 0.63
    },
    "placements": [
      {
        "shelfId": "MNU9",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff66e7"
      }
    ],
    "inventory": {
      "quantity": 60
    }
  },
  {
    "gtin": "01000138",
    "name": "Capped Mushrooms",
    "brandName": "FreshVeggies",
    "baseCategory": "Produce",
    "reportedPrice": {
      "amount": 2.89,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.09,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744998129/products/pim/4051424570002-2109712607/dr-scheller-anti-falten-gesichtscreme-argan",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.105,
      "x1": 1.0,
      "y1": 0.89,
      "aspect": 1.2739
    },
    "placements": [
      {
        "shelfId": "YIAY",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff66f4"
      }
    ],
    "inventory": {
      "quantity": 56
    }
  },
  {
    "gtin": "01000139",
    "name": "Wrapped Candies",
    "brandName": "CandyLand",
    "baseCategory": "Sweets & Confectionery",
    "reportedPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744983705/products/pim/4006000083353-699695394/nivea-bodylotion-express-normale-haut",
    "imageOutline": {
      "x0": 0.325,
      "y0": 0.0,
      "x1": 0.675,
      "y1": 1.0,
      "aspect": 0.35
    },
    "placements": [
      {
        "shelfId": "81WM",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6701"
      }
    ],
    "inventory": {
      "quantity": 59
    }
  },
  {
    "gtin": "01000140",
    "name": "Mapped Routes Guide",
    "brandName": "TravelGuides",
    "baseCategory": "Books & Media",
    "reportedPrice": {
      "amount": 7.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 8.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745000690/products/pim/59099727-1444515668/dove-men-care-antitranspirant-deostick-invisible-dry",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.22,
      "x1": 1.0,
      "y1": 0.78,
      "aspect": 1.7857
    },
    "placements": [
      {
        "shelfId": "M3Z9",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff670e"
      }
    ],
    "inventory": {
      "quantity": 30
    }
  }
]